import React from "react";

import { useStableId } from "@/lib/useStableId";

const handleBeforeUnload = function (e: BeforeUnloadEvent) {
  e.preventDefault();
};

let dropUnloadBlockersArr: (() => void)[] = [];

export const forceDropAllUnloadBlockers = () => {
  dropUnloadBlockersArr.forEach(it => it());
};

export function useUnloadBlocker() {
  const unloadBlockerId = useStableId();
  const isSetted = React.useRef(false);

  const dropUnloadBlocker = React.useCallback(() => {
    isSetted.current = false;
    dropUnloadBlockersArr = dropUnloadBlockersArr.filter(it => it !== dropUnloadBlocker);
    if (dropUnloadBlockersArr.length === 0) {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [unloadBlockerId]);

  React.useEffect(() => {
    if (isSetted.current) dropUnloadBlockersArr.push(dropUnloadBlocker);
    return () => {
      dropUnloadBlockersArr = dropUnloadBlockersArr.filter(
        it => it !== dropUnloadBlocker,
      );
    };
  }, [dropUnloadBlocker]);

  const setUnloadBlocker = React.useCallback(() => {
    isSetted.current = true;
    if (dropUnloadBlockersArr.length === 0) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }
    dropUnloadBlockersArr.push(dropUnloadBlocker);
    return dropUnloadBlocker;
  }, [unloadBlockerId, dropUnloadBlocker]);

  return { setUnloadBlocker, dropUnloadBlocker, forceDropAllUnloadBlockers };
}
